import { useQuery } from '@apollo/react-hooks';
import Divider from '@material-ui/core/Divider';
import { t } from 'ttag';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import FormField from '../FormField';
import TransferList from '../TransferList';
import Loading from '../Loading';
import useApi from '../../api';
import { USER_TYPES } from '../../utils/enums';

export const PermissionChooser = ({
  selected,
  permissionsGymIds,
  onChange,
  user_types,
}) => {
  const api = useApi();
  const { loading, data } = useQuery(api.schema.permissions.many()[0], {
    fetchPolicy: 'network-only',
    variables: { inputFilter: { types: user_types } },
  });
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <TransferList
        name='permissions'
        available={data.permissions}
        selected={selected}
        onChange={onChange}
      />
      <Divider />

      {user_types.includes(USER_TYPES.manager) && (
        <Grid container>
          <Grid item sm={6}>
            {t`Виберіть зали:`}
          </Grid>
          <Grid item sm={6}>
            <FormField
              required
              fullWidth
              query={api.schema.gyms.many()[0]}
              preInit
              dataKey='gyms'
              variables={{}}
              type='multi_select'
              margin='normal'
              label={t`Виберіть зали`}
              name='permissionsGymIds'
              variant='outlined'
              value={permissionsGymIds}
              labelKey='name'
              onChange={onChange}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default PermissionChooser;
